import { extractPrimaryCategoryFromParams } from "app/pages/industry-analysis/routes/routeUtils";
import DurationService, { BasicDurations } from "app/services/DurationService";
import { swSettings } from "app/common/services/swSettings";
import { DownloadButtonMenu } from "app/components/React/DownloadButtonMenu/DownloadButtonMenu";
import { DefaultFetchService } from "app/services/fetchService";

import { useHighLevelMetricsContext } from "../context";

import { getCategoryObject } from "./helpers";

const excelEndpoint = "api/Market/TrafficAndEngagement/Overview/Excel";

export const ExcelDownload = () => {
    const { queryParams } = useHighLevelMetricsContext();
    const { duration } = queryParams;
    const categoryParam = extractPrimaryCategoryFromParams(queryParams.category);
    const category = getCategoryObject(categoryParam);
    const last28daysParam =
        duration === BasicDurations.LAST_TWENTY_EIGHT_DAYS ? { latest: BasicDurations.LAST_TWENTY_EIGHT_DAYS } : {};

    const { from, to } = DurationService.getDurationData(queryParams.duration).forAPI;

    if (!category) {
        return;
    }

    const queryParamsExtended = {
        ...queryParams,
        ...last28daysParam,
        from,
        to,
        category: category.id,
        keys: category.forApi,
    };

    const fetcherService = DefaultFetchService.getInstance();
    const excelLink = `${excelEndpoint}?${fetcherService.requestParams(queryParamsExtended)}`;
    const downloadExcelPermitted = swSettings.current.resources.IsExcelAllowed;

    return (
        <DownloadButtonMenu
            Excel={true}
            downloadUrl={excelLink}
            excelLocked={!downloadExcelPermitted}
        />
    );
};
